export default "__VITE_ASSET__BBfT4QUS__"